import { get, put, del } from '../../lib/api'

const VNC_API = 'vnc'

/**
 * Get VNC config for a modality
 * @param {string|number} modalityId - The modality ID
 * @returns {Promise<Object>} VNC config
 */
export const getConfig = async (modalityId) => {
  const { data } = await get(`${VNC_API}/modalities/${modalityId}/config`)
  return data
}

/**
 * Create or update VNC config for a modality
 * @param {string|number} modalityId - The modality ID
 * @param {Object} config - VNC configuration
 * @returns {Promise<Object>} Updated config
 */
export const upsertConfig = async (modalityId, config) => {
  const { data } = await put(`${VNC_API}/modalities/${modalityId}/config`, config)
  return data
}

/**
 * Delete VNC config for a modality
 * @param {string|number} modalityId - The modality ID
 * @returns {Promise<Object>} Deletion result
 */
export const deleteConfig = async (modalityId) => {
  const { data } = await del(`${VNC_API}/modalities/${modalityId}/config`)
  return data
}

/**
 * Get agents available for VNC activation for a modality
 * @param {string|number} modalityId - The modality ID
 * @returns {Promise<Array>} List of agents with id and description
 */
export const getAgentsForModality = async (modalityId) => {
  const { data } = await get(`${VNC_API}/modalities/${modalityId}/agents`)
  return data
}

export default {
  getConfig,
  upsertConfig,
  deleteConfig,
  getAgentsForModality
}

